<template>
  <div>
    <el-dialog
      title="导出数据"
      :visible.sync="exportProps.dialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <el-row>
        <el-form
          :inline="true"
          ref="downloadView"
          :model="form"
          label-suffix=":"
        >
          <el-col :span="24">
            <el-form-item
              label="文件名称"
              prop="fileName"
              :rules="[{ required: true, message: '请输入文件名' }]"
              :required="true"
            >
              <el-input v-model="form.fileName">
                <template slot="append"
                  >.{{ exportProps.suffix || "xlsx" }}</template
                >
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportProps.dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="todownloadData" :loading="btnflag"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 传参示例
 * exportProps: {
    filename: "健康打卡统计表_" + dateFormat(new Date(), "yyyy-MM-dd"),   文件名
    dialogVisible: false,   弹框显示
    suffix: "zip",   文件后缀
  },
 */

export default {
  props: ["exportProps"],
  data() {
    return {
      form: {
        fileName: "",
      },
      btnflag: false,
    };
  },
  methods: {
    todownloadData() {
      this.$refs.downloadView.validate((valid) => {
        if (valid) {
          this.btnflag = true;
          let done = () => {
            this.btnflag = false;
            this.exportProps.dialogVisible = false;
            this.loading().close();
          };
          this.loading("正在导出...");
          this.$emit(
            "download",
            this.form.fileName + "." + (this.exportProps.suffix || "xlsx"),
            done
          );
        } else {
          return false;
        }
      });
    },
    // 全屏遮罩
    loading(text = "Loading") {
      return this.$loading({
        lock: true,
        text,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
  },
  watch: {
    exportProps: {
      handler(val) {
        if (val.dialogVisible) {
          this.form.fileName = val.filename;
        }
      },
      deep: true,
    },
  },
};
</script>

<style></style>
